<template>
  <div class="login-page">
    <div
      class="login-card"
      data-cy="login-header-card"
    >
      <div class="login-card-header">
        <img
          :src="logo"
          alt="nCino"
          data-cy="logo"
          class="login-logo"
        >
      </div>
      <div class="login-card-body">
        <stateful-auth
          v-if="isValidInvite && isValidConsent"
          :user-email="email"
          :init="initKey"
          :invite-guid="inviteGuid"
          :sso-token="ssoToken"
          :enote-guid="enoteGuid"
          :consent-client-id="consentClientId"
          :consent-redirect="consentRedirect"
          :consent-state="consentState"
          :init-state="initState"
          auth-context="evault"
          @title="(value) => {titleText = value}"
        />
        <h3
          v-else-if="!isValidInvite"
          style="color: red"
        >
          This invite link is no longer valid.
        </h3>
        <h3
          v-else-if="!isValidConsent"
          style="color: red"
        >
          This consent link is no longer valid.
        </h3>
      </div>
    </div>
    <div class="login-footer">
      © {{ new Date().getFullYear() }} nCino, All Rights Reserved
    </div>
  </div>
</template>

<script>
import statefulAuth from '~/components/common/v2/authorization/_statefulAuth.vue'
import logo from '~/assets/images/logos/ncino_evault_logo_dark.svg'
import { isUserInviteValid } from './graphql/users/user_access.gql'
import { apiClient } from './graphql/api_client_queries.gql'

export default {
  name: 'Login',

  components: {
    'stateful-auth': statefulAuth
  },

  data () {
    return {
      email: '',
      logo: logo,
      inviteGuid: '',
      isValidInvite: true,
      titleText: '',
      initKey: 'init',
      initState: 'init',
      ssoToken: '',
      enoteGuid: '',
      isValidConsent: true,
      consentClientId: '',
      consentRedirect: '',
      consentState: ''
    }
  },

  created () {
    if (this.$route && this.$route.query.inviteGuid) {
      this.inviteGuid = this.$route.query.inviteGuid
      this.$apollo.query({
        query: isUserInviteValid,
        variables: {
          inviteGuid: this.inviteGuid
        },
        fetchPolicy: 'no-cache'
      }).then(({ data }) => {
        const { response } = data.userInvite
        this.isValidInvite = !!response
        this.initKey = 'start'
      }).catch(err => {
        this.isValidInvite = false
        console.log(`Could not find valid invite with ID ${this.inviteGuid}:`, err)
      })
    } else if (this.$route && this.$route.query.ssoToken) {
      this.ssoToken = this.$route.query.ssoToken
      this.initState = 'requestSsoSignIn'
      this.enoteGuid = this.$route.query.enoteGuid ? this.$route.query.enoteGuid : ''
    } else if (this.$route && this.$route.query.prompt && this.$route.query.prompt === 'consent' && this.$route.query.client_id) {
      this.consentClientId = this.$route.query.client_id
      this.consentRedirect = this.$route.query.redirect_uri
      this.consentState = this.$route.query.state
      this.$apollo.query({
        query: apiClient,
        variables: {
          clientId: this.$route.query.client_id
        },
        fetchPolicy: 'no-cache'
      }).then(({ data }) => {
        const response = data.apiClient
        this.isValidConsent = response != null && response.active
      }).catch(err => {
        this.isValidConsent = false
        console.log(`Could not find valid consent with ID ${this.consentClientId}:`, err)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.login-page {
  min-height: 100vh;
  background: #F7F7F7;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 100px 16px 24px;
}
.login-card {
  width: 100%;
  max-width: 535px;
  background: #FFFFFF;
  border-radius: 16px;
  box-shadow:
    0 1px 1.5px rgba(31, 31, 31, 0.04),
    0 2px 5px rgba(31, 31, 31, 0.10),
    0 3px 9px 6px rgba(31, 31, 31, 0.05);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.login-card-header {
  height: 80px;
  box-sizing: border-box;
  padding: 24px 16px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/*
 * The design sizes the nCino mark at 138x35 inside a 40px header slot.
 * This asset's canvas is 189x29 and the mark fills its full height, so
 * rendering at 35px puts the mark at exactly 138x35. Sized off the mark
 * rather than the canvas so it matches the eSign lockup in signing_room,
 * whose canvas is taller only because of the descender in "eSign".
 */
.login-logo {
  height: 35px;
  width: auto;
}
/*
 * The design nests a 16px-inset frame inside the card's own 16px body padding,
 * so content sits 32px in from each card edge (535px card -> 471px fields).
 * The action bar escapes this with negative margins - see .auth-card-footer
 * in _statefulAuth.vue, which must cancel the same 32px.
 */
.login-card-body {
  padding: 16px 32px 32px;
}
.login-footer {
  margin-top: auto;
  padding-top: 40px;
  font-family: 'Open Sans', sans-serif;
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
  color: var(--color-text-secondary, #6D6D6D);
  text-align: center;
}
</style>
